import { render, staticRenderFns } from "./StaticQRSticker.vue?vue&type=template&id=9fca0c70"
import script from "./StaticQRSticker.vue?vue&type=script&lang=js"
export * from "./StaticQRSticker.vue?vue&type=script&lang=js"
import style0 from "./StaticQRSticker.vue?vue&type=style&index=0&id=9fca0c70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports